import { EntitlementResourceEntityType, EntitlementType } from '@prisma/client';

export type TEntitlements = {
  entitlements: TEntitlement[];
};

export type TEntitlement = {
  id: string;
  companyId: number;
  entitlementType: EntitlementType;
  entitlementSubType: string;
  entityType: EntitlementResourceEntityType;
  entityId: string;
  startDate: string;
  endDate?: string;
};

export type TEntitlementWithEntityName = TEntitlement & {
  entityName: string;
};

export type EntitlementResource = {
  id: string;
  entitlementId: string;
  entityType: EntitlementResourceEntityType;
  entityId: string;
  startDate: string;
  endDate?: string;
};

export enum EntitlementFeatureType {
  COMPLIANCE = 'COMPLIANCE',
}
